// removed by extract-text-webpack-plugin
module.exports = {"popupBody":"_2d9gdg-ZoraW2CbmZqlZIn","popup-show":"GQbyDcnSzKjavsutZDx99"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Game/SubComponents/Popup/index.css
// module id = 182
// module chunks = 0